import styled, { css } from 'styled-components';

import { Button } from '@/components/ui/Button/Button';
import { BREAKPOINTS } from '@/constants/breakpoints';

export const Wrapper = styled.div<{
  $isOpen: boolean;
  $isBordered: boolean;
  $isFullWidth: boolean;
  $shouldExpand: boolean;
}>`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  border: 1px solid var(--border-main);
  border-color: transparent;
  border-radius: 100px;
  box-shadow: 0px 17px 34px 0px rgba(151, 151, 151, 0.08);
  background: var(--bg-main);
  will-change: width, top, left, transform;
  width: ${({ $isFullWidth }) => ($isFullWidth ? '100%' : 'auto')};

  overflow: hidden;

  @media (max-width: ${BREAKPOINTS.tablet}) {
    padding-inline: 15px;
  }

  @media (min-width: ${BREAKPOINTS.tablet}) {
    padding: 7px 10px 7px 20px;
  }

  svg {
    color: var(--textAndLabels-tertiary);
    transition: color 0.3s ease;
  }

  ${({ $isBordered }) =>
    $isBordered &&
    css`
      border-color: var(--border-main);
      background: var(--bg-secondary);
      box-shadow: none;
    `}

  ${({ $shouldExpand }) =>
    $shouldExpand &&
    css`
      padding-inline: 14px !important;
    `}

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      z-index: 10;
      border-color: var(--brand-main);
      background: var(--bg-main);

      & > svg:first-of-type {
        color: var(--brand-main);
      }
    `}

  transition: width 0.2s ease;
`;

export const SearchInput = styled.input`
  font-size: 16px;
  flex: 1;
  border: none;
  outline: none;
  background: none;
  text-overflow: ellipsis;
  color: var(--textAndLabels-main);

  &:placeholder-shown {
    text-overflow: ellipsis;
  }
`;

export const ClearButton = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-right: 5px;

  svg {
    width: 13px;
    height: 13px;
  }

  &:hover {
    svg {
      color: var(--textAndLabels-main);
    }
  }
`;

export const FiltersButton = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 100px;

  padding: 10px 15px;
  @media (max-width: ${BREAKPOINTS.tablet}) {
    padding: 5px 10px;
  }

  transition: background 0.3s ease;

  &:hover {
    background: var(--bg-secondary);
  }

  @media (max-width: ${BREAKPOINTS.tablet}) {
    &::before {
      position: absolute;
      content: ' ';
      left: 0%;
      background-color: var(--border-secondary);
      height: 100%;
      width: 1px;
    }
    & svg {
      width: 18px;
      height: 16px;
    }
  }
`;

export const SubmitButton = styled(Button)`
  display: none;
  @media (min-width: ${BREAKPOINTS.tablet}) {
    display: flex;
  }
`;

export const SearchIconWrapper = styled.div`
  display: flex;
  & > svg {
    width: 16px !important;
  }
`;
